import { handleResponse, handleError, headerset } from "../apiUtils";

// ============================================
// INTERFACES FILTRI
// ============================================

export interface FiltriFasiFrazioniRepartoApi {
    page?: number;
    numero_record?: number;
    search?: string;
    solo_ostacoli?: boolean;
    data_da?: string;
    data_a?: string;
}

// ============================================
// BASE URL
// ============================================

const baseUrl = (repartoId: number, faseFrazioneId?: number) => {
    let url = process.env.API_URL + `/api/schedulazione/reparti/${repartoId}/fasi_frazioni/`;
    if (faseFrazioneId) {
        url += faseFrazioneId + "/";
    }
    return url;
};

// ============================================
// QUERY STRING BUILDER
// ============================================

const buildQueryString = (filtri: FiltriFasiFrazioniRepartoApi): string => {
    const params = new URLSearchParams();

    if (filtri.page) params.append("page", filtri.page.toString());
    if (filtri.numero_record) params.append("numero_record", filtri.numero_record.toString());
    if (filtri.search) params.append("search", filtri.search);
    if (filtri.solo_ostacoli) params.append("solo_ostacoli", "1");
    if (filtri.data_da) params.append("data_da", filtri.data_da);
    if (filtri.data_a) params.append("data_a", filtri.data_a);

    return params.toString();
};

// ============================================
// API FUNCTIONS
// ============================================

/**
 * Fetch lista fasi frazioni per reparto
 */
export function fetchFasiFrazioniReparto(repartoId: number, filtri: FiltriFasiFrazioniRepartoApi = {}) {
    let url = baseUrl(repartoId);
    const queryString = buildQueryString(filtri);
    if (queryString) {
        url += `?${queryString}`;
    }

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * Fetch singola fase frazione per reparto
 */
export function getFaseFrazioneReparto(repartoId: number, faseFrazioneId: number) {
    const url = baseUrl(repartoId, faseFrazioneId);

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * PATCH dedicato all'assegnazione operatore di una FaseFrazione.
 * Endpoint indipendente dal contesto reparto (usabile anche da altre pagine).
 */
export function saveFaseFrazioneOperatore(
    faseFrazioneId: number,
    operatoreId: number | null,
) {
    const url = process.env.API_URL + `/api/schedulazione/fasi_frazioni/${faseFrazioneId}/operatore/`;

    return fetch(url, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
        body: JSON.stringify({ operatore: operatoreId }),
    })
        .then(handleResponse)
        .catch(handleError);
}
